// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-group {
  display: flex;
  gap: 12px;
}

.btn-primary,
.btn-secondary {
  flex: 1;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s;
}

.btn-primary {
  background-color: var(--primary);
  color: white;
  box-shadow: 0 4px 6px rgba(242, 92, 36, 0.2);
}

.btn-primary:hover:not(:disabled) {
  background-color: var(--primary-hover);
  box-shadow: 0 6px 8px rgba(242, 92, 36, 0.25);
}

.btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-primary .material-icons-round {
  font-size: 20px;
  transition: transform 0.2s;
}

.btn-primary:hover:not(:disabled) .material-icons-round {
  transform: scale(1.1);
}

.btn-secondary {
  background-color: var(--surface-light);
  color: var(--text-primary);
  border: 1px solid var(--border-light);
}

.btn-secondary:hover:not(:disabled) {
  background-color: var(--background-light);
}

.btn-secondary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-secondary .material-icons-round {
  font-size: 20px;
}

@media (max-width: 400px) {
  .button-group {
    gap: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/taskpane/components/ActionButtons/ActionButtons.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,OAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,QAAQ;EACV;AACF","sourcesContent":[".button-group {\n  display: flex;\n  gap: 12px;\n}\n\n.btn-primary,\n.btn-secondary {\n  flex: 1;\n  padding: 12px 16px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: 'Inter', sans-serif;\n  cursor: pointer;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  transition: all 0.2s;\n}\n\n.btn-primary {\n  background-color: var(--primary);\n  color: white;\n  box-shadow: 0 4px 6px rgba(242, 92, 36, 0.2);\n}\n\n.btn-primary:hover:not(:disabled) {\n  background-color: var(--primary-hover);\n  box-shadow: 0 6px 8px rgba(242, 92, 36, 0.25);\n}\n\n.btn-primary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btn-primary .material-icons-round {\n  font-size: 20px;\n  transition: transform 0.2s;\n}\n\n.btn-primary:hover:not(:disabled) .material-icons-round {\n  transform: scale(1.1);\n}\n\n.btn-secondary {\n  background-color: var(--surface-light);\n  color: var(--text-primary);\n  border: 1px solid var(--border-light);\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background-color: var(--background-light);\n}\n\n.btn-secondary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btn-secondary .material-icons-round {\n  font-size: 20px;\n}\n\n@media (max-width: 400px) {\n  .button-group {\n    gap: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
